var Separator_module_default = { separator: "_separator_13qwf_8" };
//#endregion
export { Separator_module_default as default };

//# sourceMappingURL=Separator.module.js.map